























import {Component, Vue} from "vue-property-decorator";
import {DisplayUtils} from "@/display-utils";
import {CommonConstant} from "@/common-constant";
import {GtmScript} from "@/router/gtm-script";

@Component
    export default class RegistComplete extends Vue {
        /** 共通ID表示名 */
        commonIdName: string = CommonConstant.COMMON_ID_NAME;

        /** 戻り先URLの存在 */
        exitRedirectUrl: boolean = false;

        /** マイページに戻るボタンの表示制御 */
        isBackMyPageDisplay: boolean;

        created() {
            // セッションストレージの戻り先URLの存在判定
            this.exitRedirectUrl = (sessionStorage.getItem("redirectUrl") != null) && (sessionStorage.getItem("redirectUrl") != "");
            // スマホアプリ、または、BSECからの遷移の場合、マイページに戻るボタンを非表示とする
            this.isBackMyPageDisplay = !(DisplayUtils.isSmartphoneAppMode() || DisplayUtils.isBsecMode());
        }

        /** 他サービスには、セッション・ストレージのURLを削除してから遷移する */
        returnExternalService() {
            // セッションストレージからredirectUrlを削除する前にGTMイベントを通知する
            GtmScript.noticeMyPageRedirectClick()

            let url = sessionStorage.getItem("redirectUrl");
            if (url) {
                sessionStorage.removeItem("redirectUrl");
                window.location.href = url;
            } else {
                // 直前にセッションストレージからデータが消えた場合、マイページに遷移
                console.log("redirectUrl is none. move mypage.");
                this.$router.push("/client/mypage")
            }
        }

        /** マイページにはrouterで戻る */
        backMypage() {
            this.$router.push("/client/mypage")
        }
    }

